import { Select, Tag, Tooltip } from 'antd';
import getFormatMessage from '../../../../../locales/get-format-message';

// const { Option } = Select;

interface IProps {
  readonly selectedValues: string[];
  readonly onEmailChange: (value: string[]) => void;
  // readonly memberList: ReadonlyArray<IAPIStudioMemberItem>;
  readonly isValidEmail: (email: string) => boolean;
  readonly checkExistingUser: (email: string) => boolean;
}

export const VersionSelect = (props: IProps) => {
  const { onEmailChange, selectedValues, isValidEmail, checkExistingUser } =
    props;
  const handleVersionChange = (value: string[]) => {
    onEmailChange(value);
  };

  const handleEmailInputCreate = () => {
    try {
      const trimmedVersions = selectedValues
        .map((selectedValues) => selectedValues.trim())
        .filter(Boolean);
      // console.log('trimmedVersions=========',trimmedVersions);
      if (trimmedVersions.length > 0) {
        const uniqueValues: string[] = [];
        trimmedVersions.forEach((value) => {
          if (!uniqueValues.includes(value)) {
            uniqueValues.push(value);
          }
        });
        props.onEmailChange(uniqueValues);
      }
    } catch (error: any) {
      throw new Error(error.message);
    }
  };

  // 新div为挂载容器
  const tooltipContainer = document.createElement('div');
  tooltipContainer.classList.add('custom-tooltip-container');
  document.body.appendChild(tooltipContainer);

  return (
    <div>
      <Select
        mode="tags"
        value={selectedValues}
        onChange={handleVersionChange}
        className="tag-select"
        placeholder={getFormatMessage('input_many_email')}
        onInputKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleEmailInputCreate();
          }
        }}
        open={false}
        dropdownStyle={{ height: 0 }}
        tokenSeparators={[',', ' ', ';']}
        tagRender={(props) => {
          const { label, value, closable, onClose } = props;
          const isTagValid = isValidEmail(value);
          const isExistingUser = checkExistingUser(value);
          const tagColor = isExistingUser
            ? 'red'
            : isTagValid
            ? 'default'
            : 'red';
          const tagTitle = isExistingUser
            ? getFormatMessage('del_already_user')
            : isTagValid
            ? ''
            : getFormatMessage('del_err_email');
          const tagContent = (
            <span className="custom-tag-content">{label}</span>
          );
          return (
            // getPopupContainer指定挂载容器
            <Tooltip
              title={tagTitle}
              getPopupContainer={() => tooltipContainer}
              overlayClassName="edit-member-tooltip"
            >
              <Tag
                closable={closable}
                onClose={onClose}
                style={{ marginRight: 8 }}
                color={tagColor}
                className="custom-tag"
              >
                {tagContent}
              </Tag>
            </Tooltip>
          );
        }}
      ></Select>
    </div>
  );
};
